export const LANGS = {
  EN: 'en_CA',
  FR: 'fr_CA',
};
